export default __webpack_public_path__ + "static/media/halal.18485984.png";